import React from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";

const SearchResultCard = props => {
    const {
        title,
        level,
        icon,
        badge,
        show_route,
        image,
        additionalInfo,
        isCenter,
    } = props;

    const renderImage = (image) => {
        if (image) {
            return (
                <div className="position-relative">
                    <img className="overflow-hidden"
                         style={{ width: "44px", height: "44px", objectFit: "cover" }}
                         alt={`profile picture of ${title}`}
                         src={image}/>
                </div>
            );
        }

        return (
            <div className="position-relative align-content-center">
                <span className="overflow-hidden h2 text-center">
                    <i className="fas fa-solid fa-location-dot pt-2"
                       style={{ width: "44px", height: "44px" }}></i>
                </span>
            </div>
        )
    };

    const renderBadge = (badge, level, icon) => {
        if(!badge) return;
        return (
            <span className={`badge level-${level}-pill mx-1`} style={{ fontSize: "10px" }}>
                    <i className={icon}></i>&nbsp; Level {level}
            </span>
        )
    }

    return (
        <div className="w-100 p-2 d-inline-block text-truncate">
            <a
                className="text-white"
                href={show_route}
                target="_blank"
            >
                <div className="rounded clickable" style={{ backgroundColor: "#2d3237" }}>
                    <div className="d-flex">
                        {renderImage(image)}
                        <div className={classnames("flex-grow-1 overflow-auto ps-1 small",
                            { "align-content-center" : isCenter }
                        )}>
                            <p className="text-truncate fw-bold mb-0">
                                {badge && <i className={icon}/>}
                                &nbsp;{title}
                            </p>
                            {renderBadge(badge,level,icon)}
                            {additionalInfo && (
                                <span className="text-muted" style={{ fontSize: "10px" }}>
                                    &nbsp;{additionalInfo}
                                 </span>
                            )}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};

SearchResultCard.propTypes = {
    title: PropTypes.string.isRequired,
    level: PropTypes.number,
    icon: PropTypes.string,
    badge: PropTypes.bool,
    show_route: PropTypes.string.isRequired,
    image: PropTypes.string,
    additionalInfo: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
    ]),
    isCenter: PropTypes.bool,
};

SearchResultCard.defaultProps = {
    badge: false,
    isCenter: false,
}

export default SearchResultCard;
